module.exports = __webpack_public_path__ + "static/media/IMG_1911.b0beca68.PNG";